const s3Folders = {
  generatedCreatives: 'GeneratedCreatives',
  uploadedCreatives: 'UploadedCreatives',
  products: 'Products',
  logos: 'Logos',
  backgroundTextures: 'BackgroundTextures',
  backgroundImages: 'BackgroundImages',
  enhancements: 'Enhancements',
}

export default s3Folders